import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../type';

export const surveySelector = (state: RootState) => state.survey;

export const isSurveySelector = createSelector(
  surveySelector,
  (state) => state
);
